import React from "react";
import { useParams } from "react-router-dom";
import blogData from "../../blogData";
import { Helmet } from "react-helmet";

export default function SingleBlogPage() {
 

     let { slug } = useParams();
  console.log("Slug from URL:", slug);

  let data = blogData.find((x) => x.slug === slug);
  console.log("Matched Blog:", data);
    
  
    
  return (
    <>
  <Helmet>
            <title>Travel & Stay Blog | V Hotel The Grand Shoba </title>

            <meta name="description" content="Read the latest travel and stay tips from V Hotel The Grand Shoba. Find hotel insights, guides near Delhi Airport, and stories to make every trip easier." />
            <meta name="keywords" content="Corporate Hall Near Delhi Airport" />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={`https://www.vhotelthegrandshoba.com/${slug}`}/>

         </Helmet>
        <div
      className="hero-section text-white text-center d-flex align-items-center justify-content-center"
      style={{
        backgroundImage: `url(/images/blog_banner.jpg)`,
        backgroundSize: "cover",
        
        backgroundPosition: "center",
        height: "60vh",
        position: "relative",
      }}
    >
      <div
        className=" corpo-hero-card  p-4 rounded"
        style={{ maxWidth: "90%" }}
      >
        <h1 className="display-6 fw-bold text-uppercase" style={{color:"#AD8B3A"}}>Blog - Travel & Stay Blog </h1>
       
      </div>
    </div>

       <div className="container py-5">
      {/* Blog Title */}
      <div className="text-center mb-4">
        
        <p className="text-muted">
           <strong> Posted</strong>  on Sept 6, 2025
        </p>
      </div>

      {/* Blog Image */}
    

      {/* Blog Content */}
      <div className="blog-content  ">
       

        {/* Sub Heading */}
{data?.name && (
  <>
    <h1 style={{ paddingTop: "40px", textAlign: "start" }}>
      {data.name}
    </h1>
    {data?.description && (
      <p style={{ textAlign: "justify", paddingBottom:"20px" }}>
        {data.description}
      </p>
    )}
  </>
)}
  <div className="mb-4" style={{height:"650px"}}>
        <img
          src={data?.img}
          alt="Cochin Sightseeing"
          className="img-fluid rounded shadow-sm w-100"
          style={{ objectFit: "cover", height: "650px" }}
        />
      </div>

{[1, 2, 3, 4, 5, 6].map((i) => (
  data?.[`heading${i}`] && (
    <div key={i}>
      <h3 style={{ textAlign: "start" }}>
        {data[`heading${i}`]}
      </h3>
      {data?.[`description${i}`] && (
        <p style={{ textAlign: "justify" }}>
          {data[`description${i}`]}
        </p>
      )}
    </div>
  )
))}


      </div>

     
    </div>

    </>
 
  );
}
